import { Menu, MenuItem, Sidebar, useProSidebar } from 'react-pro-sidebar';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Link, useLocation } from 'react-router-dom';
import { ArrowBackIosNew } from '@mui/icons-material';
import React, { useMemo } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RouterOutlinedIcon from '@mui/icons-material/RouterOutlined';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import ChatIcon from '@mui/icons-material/Chat';
import { useDevicesStore, useObjectsStore, useSettingsStore, useUserStore } from '../../stores';
import { hexToRgba } from './utils';
import { menuItemStyles, themes } from './constants';

const CustomSideBar = () => {
  const { pathname } = useLocation();
  const { collapseSidebar, toggleSidebar, broken } = useProSidebar();
  const { theme } = useSettingsStore();
  const { user } = useUserStore();
  const { objectsExist } = useObjectsStore();
  const { devicesExist } = useDevicesStore();

  const supportChatVisible = process.env.REACT_APP_FEATURE_SUPPORT_CHAT === 'true';

  // menu sidebar:
  const menuItems = useMemo(
    () => [
      { label: 'Мониторинг', to: '/', icon: <DashboardIcon />, visible: devicesExist },
      { label: 'Устройства', to: '/devices', icon: <RouterOutlinedIcon />, visible: objectsExist },
      { label: 'Объекты', to: '/objects', icon: <ApartmentIcon />, visible: true },
      { label: 'Интеграции', to: '/integrations', icon: <ConnectWithoutContactIcon />, visible: devicesExist && objectsExist },
      { label: 'События', to: '/events', icon: <EventNoteIcon />, visible: devicesExist && objectsExist },
      // { label: 'Оплата услуг', to: '/payments', icon: <AccountBalanceWalletOutlinedIcon />, visible: true },
      { label: 'Техподдержка', to: '/support', icon: <SupportAgentIcon />, visible: true },
      { label: 'Чат с поддержкой', to: '/support-chat', icon: <ChatIcon />, visible: supportChatVisible },
      { label: 'Инструкции', to: '/instruction', icon: <MenuBookIcon />, visible: true },
      { label: 'Личный кабинет', to: '/user', icon: <AccountCircleRoundedIcon />, visible: true },
    ],
    [devicesExist, objectsExist, supportChatVisible]
  );
  return (
    <div className="flex select-none">
      <Sidebar
        rootStyles={{
          color: themes[theme].sidebar.color,
          borderWidth: 0,
        }}
        backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, 1)}
        width="280px"
        breakPoint="sm">
        <Menu menuItemStyles={menuItemStyles(theme)}>
          <MenuItem
            onClick={() => {
              collapseSidebar();
            }}
            className="mb-10"
            icon={<MenuRoundedIcon />}>
            <p className="font-bold">Мира</p>
          </MenuItem>
          {user?.is_organization && (
            <MenuItem
              className="mb-6"
              onClick={() => broken && toggleSidebar()}
              component={<Link to={process.env.REACT_APP_BASE_URL_COMPANY} />}
              icon={<ArrowBackIosNew />}>
              В кабинет компании
            </MenuItem>
          )}

          {menuItems
            .filter(({ visible }) => visible)
            .map(({ label, to, icon }) => (
              <MenuItem active={pathname === to} onClick={() => broken && toggleSidebar()} key={to} component={<Link to={to} />} icon={icon}>
                {label}
              </MenuItem>
            ))}
        </Menu>
      </Sidebar>
    </div>
  );
};
export default CustomSideBar;
